export function computeVswr(gamma) {
    const mag = Math.hypot(gamma.re, gamma.im);
    if (mag >= 1)
        return Number.POSITIVE_INFINITY;
    return (1 + mag) / (1 - mag);
}
//# sourceMappingURL=vswr.js.map